module.exports = __webpack_public_path__ + "img/awaiting.218ed42e.svg";